import React from 'react';
export function Card({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`bg-white rounded-2xl border-2 border-amber-200 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden print:shadow-none print:rounded-lg print:border print:border-stone-300 ${className}`} data-id="element-649">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`px-4 sm:px-6 py-4 border-b-2 border-amber-100 bg-gradient-to-r from-amber-50 via-orange-50/50 to-amber-50 print:bg-white print:px-4 print:py-3 print:border-b print:border-stone-200 ${className}`} data-id="element-650">
      {children}
    </div>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-4 sm:p-6 print:p-3 ${className}`} data-id="element-651">{children}</div>;
}